// Common function to format price
export function formatPrice(price) {
    // Add any formatting logic you need here
    return `$${price}`;
}
